<template>
  <section class="sp">
    <div class="sp-blob sp-blob--1"></div>
    <div class="sp-blob sp-blob--2"></div>

    <div class="sp-card">
      <div class="sp-header">
        <div class="sp-icon">
          <i class="pi pi-search"></i>
        </div>
        <h1 class="sp-title">الاستعلام عن الحجز</h1>
        <p class="sp-subtitle">أدخل رقم الحجز (Reservation ID) للاستعلام عن حالة الحجز</p>
      </div>

      <form @submit.prevent="sendForm()" class="sp-form">
        <div class="sp-field" :class="{ 'sp-field--error': v$.reservation_number.$error }">
          <label class="sp-label" for="reservationNumber">رقم الحجز (Reservation ID)</label>
          <div class="sp-input-wrap">
            <i class="pi pi-id-card sp-input-icon"></i>
            <InputText
              id="reservationNumber"
              v-model="reservation_number"
              placeholder="مثال: 2479"
              dir="ltr"
              class="sp-input"
            />
          </div>
          <span class="sp-error" v-if="v$.reservation_number.$error">
            <i class="pi pi-exclamation-circle"></i> برجاء إدخال رقم الحجز
          </span>
        </div>

        <button type="submit" class="sp-btn" :disabled="formSending">
          <i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i>
          <i class="pi pi-search" v-else></i>
          {{ formSending ? 'جاري البحث...' : 'بحث' }}
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import InputText from 'primevue/inputtext';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from 'axios';
import Swal from 'sweetalert2';
import { websiteTexts } from '@/websiteTexts';

export default {
    name: "search-page",
    components: {
        InputText
    },
    data() {
        return {
            v$: useVuelidate(),
            reservation_number: null,
            formSending: false
        }
    },
    validations() {
        return {
            reservation_number: { required },
        };
    },
    computed: {
        websiteTexts() {
            return websiteTexts;
        }
    },
    methods: {
        sendForm() {
            this.v$.$validate();
            if (!this.v$.$error) {
                const formData = new FormData();
                formData.append('reservation_number', this.reservation_number);
                this.formSending = true;

                axios
                    .post('/check_reservation', formData)
                    .then((response) => {
                        this.formSending = false;
                        const result = response.data.data || {};
                        const messages = result.messages || {};
                        if(result.accepted == true) {
                            Swal.fire({
                                position: "center",
                                icon: "success",
                                html: (messages.accept_message || websiteTexts.data.confirm_text || '').replace(/&nbsp;/g, ' '),
                            });
                        }
                        if(result.accepted == false) {
                            if(response.data.message == "الحجز موجود وتمت الرفض") {
                                Swal.fire({
                                    position: "center",
                                    icon: "error",
                                    html: (messages.reject_message || websiteTexts.data.reject_text || '').replace(/&nbsp;/g, ' '),
                                });
                            }
                            else if(response.data.message == "الحجز موجود وما زال في قائمة الانتظار") {
                                Swal.fire({
                                    position: "center",
                                    icon: "warning",
                                    html: (messages.waiting_message || websiteTexts.data.wait_text || '').replace(/&nbsp;/g, ' '),
                                });
                            }
                            else if(response.data.message == "wating_certification") {
                              Swal.fire({
                                position: "center",
                                icon: "warning",
                                html: "<p class='text-center'>برجاء التواصل عبر الرقم <a href='https://wa.me/+201280194879' class='text-info' target='_blank'>01280194879</a> <br />  لارفاق صوره الشهاده المعتمده باسم الطالب ودرجته خلال 48 ساعه وذلك لعدم رفض الطالب</p>",
                              });
                            }
                            else if(response.data.message == "الحجز غير موجود") {
                                Swal.fire({
                                    position: "center",
                                    icon: "error",
                                    title: 'الحجز غير موجود',
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        this.formSending = false;
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: error.response.data.message,
                        });
                    });
            }
        }
    }
}
</script>

<style scoped>
.sp {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  position: relative;
  overflow: hidden;
  background: linear-gradient(150deg, #f5f6ff 0%, #eef0ff 100%);
}

.sp-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.18;
  pointer-events: none;
}

.sp-blob--1 {
  width: 420px;
  height: 420px;
  background: var(--primary, #5b5fef);
  top: -120px;
  right: -100px;
  animation: blob-drift 8s ease-in-out infinite alternate;
}

.sp-blob--2 {
  width: 320px;
  height: 320px;
  background: var(--accent, #7c4dff);
  bottom: -100px;
  left: -80px;
  animation: blob-drift 10s ease-in-out infinite alternate-reverse;
}

@keyframes blob-drift {
  from { transform: translate(0, 0) scale(1); }
  to   { transform: translate(20px, 15px) scale(1.06); }
}

.sp-card {
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(91, 95, 239, 0.1), 0 4px 16px rgba(0,0,0,0.06);
  padding: 3rem 2.5rem;
  width: 100%;
  max-width: 440px;
  position: relative;
  z-index: 1;
}

/* ── Header ── */
.sp-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.sp-icon {
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, var(--primary, #5b5fef), var(--accent, #7c4dff));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;
  box-shadow: 0 12px 32px rgba(91, 95, 239, 0.3);
}

.sp-icon i {
  font-size: 1.75rem;
  color: #fff;
}

.sp-title {
  font-size: 1.55rem;
  font-weight: 700;
  color: #1e1b4b;
  margin: 0 0 0.5rem;
  line-height: 1.3;
}

.sp-subtitle {
  font-size: 0.92rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.7;
}

/* ── Form ── */
.sp-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.sp-field {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.sp-label {
  font-size: 0.88rem;
  font-weight: 600;
  color: #374151;
}

.sp-input-wrap {
  position: relative;
}

.sp-input-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--primary, #5b5fef);
  font-size: 1rem;
  pointer-events: none;
  z-index: 1;
}

.sp-input-wrap :deep(.p-inputtext) {
  width: 100%;
  padding: 0.85rem 2.75rem 0.85rem 1rem;
  border-radius: 12px;
  border: 1.5px solid #e5e7eb;
  font-family: inherit;
  font-size: 1rem;
  color: #1f2937;
  background: #fafafa;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  direction: ltr;
  text-align: right;
  letter-spacing: 0.03em;
}

.sp-input-wrap :deep(.p-inputtext::placeholder) {
  color: #9ca3af;
  direction: rtl;
}

.sp-input-wrap :deep(.p-inputtext:focus) {
  border-color: var(--primary, #5b5fef);
  box-shadow: 0 0 0 3px rgba(91, 95, 239, 0.12);
  background: #fff;
  outline: none;
}

.sp-field--error .sp-input-wrap :deep(.p-inputtext) {
  border-color: #ef4444;
  background: #fff8f8;
}

.sp-field--error .sp-input-wrap :deep(.p-inputtext:focus) {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.sp-error {
  font-size: 0.8rem;
  color: #ef4444;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

/* ── Button ── */
.sp-btn {
  width: 100%;
  padding: 0.9rem 1.5rem;
  background: linear-gradient(135deg, var(--primary, #5b5fef), var(--accent, #7c4dff));
  color: #fff;
  border: none;
  border-radius: 12px;
  font-family: inherit;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-shadow: 0 8px 24px rgba(91, 95, 239, 0.3);
  transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;
}

.sp-btn:hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(91, 95, 239, 0.35);
}

.sp-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 6px 16px rgba(91, 95, 239, 0.25);
}

.sp-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* ── Responsive ── */
@media (max-width: 480px) {
  .sp-card {
    padding: 2rem 1.5rem;
    border-radius: 20px;
  }

  .sp-title {
    font-size: 1.3rem;
  }

  .sp-icon {
    width: 60px;
    height: 60px;
  }

  .sp-icon i {
    font-size: 1.4rem;
  }
}
</style>
